























import Vue from 'vue';
import { Prop, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { EPaymentMethod } from '@/helpers/enums';
import { Payment } from '@/classes/Checkout/Payment';
import { ICheckoutCartOfferPrice } from '@/interfaces/Checkout';

const CheckoutModule = namespace('App/Checkout');

@Component
export default class InvoiceTotal extends Vue {
  @Prop()
  private invoice: any;

  @Prop()
  private readonly isRenewal: boolean;

  @Prop()
  private readonly hasOfferDetails: boolean;

  @Prop({ default: false })
  private hasRewardsPoints: boolean;

  @Prop()
  private selectedOfferPrice: ICheckoutCartOfferPrice;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment!: Payment;

  private get ABPrice() {
    return this.$route.query.p === '1';
  }

  private get renewalPrice(){
    return !this.isRenewal &&
           (this.selectedOfferPrice && this.selectedOfferPrice.price);
  }

  private get points(){
    return this.selectedOfferPrice &&
           this.selectedOfferPrice.points_price &&
           this.hasRewardsPoints;
  }

  private get totalAmount(){
    return this.selectedOfferPrice &&
           this.selectedOfferPrice.price &&
           this.selectedOfferPrice.points_price &&
           this.invoice.totalAmount;
  }

  private get offerPrice(){
    return this.invoice.totalAmount > 0 &&
    (this.selectedOfferPrice && this.selectedOfferPrice.price);
  }


  private get installmentsNumber(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.number
    );
  }

  private get installmentsPrice(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.amount
    );
  }

  private get shouldShow() {
    const isCreditCard = this.payment.selectedPaymentMethod === EPaymentMethod.creditCard;
    const hasInstallments = this.installmentsNumber > 1;

    return this.ABPrice && isCreditCard && hasInstallments;
  }

  private get isMobile (): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
